import { supabase } from './supabase.js';

export const authService = {
  async signUp(email, password, metadata = {}) {
    const { data, error } = await supabase.auth.signUp({
      email,
      password,
      options: {
        data: metadata
      }
    });
    
    if (error) throw error;
    return data;
  },

  async signIn(email, password) {
    try {
      console.log('Attempting sign in for:', email);
      console.log('Supabase URL:', import.meta.env.VITE_SUPABASE_URL);
      
      const { data, error } = await supabase.auth.signInWithPassword({
        email,
        password
      });
      
      console.log('Sign in response:', { data, error });
      
      if (error) {
        console.error('Sign in error details:', error);
        throw error;
      }
      
      return data;
    } catch (err) {
      console.error('Sign in exception:', err);
      throw err;
    }
  },

  async signInWithMagicLink(email) {
    try {
      console.log('🔗 Sending magic link to:', email);
      console.log('🔗 Current origin:', window.location.origin);
      console.log('🔗 Current URL:', window.location.href);
      
      const redirectTo = `${window.location.origin}/auth/callback`;
      console.log('🔗 Redirect URL will be:', redirectTo);
      
      const { data, error } = await supabase.auth.signInWithOtp({
        email,
        options: {
          emailRedirectTo: redirectTo,
          // Add these options to help with debugging
          shouldCreateUser: false, // Only sign in existing users
        }
      });
      
      console.log('🔗 Magic link response data:', data);
      console.log('🔗 Magic link response error:', error);
      
      if (error) {
        console.error('❌ Magic link error details:', error);
        throw error;
      }
      
      console.log('✅ Magic link sent successfully');
      return data;
    } catch (err) {
      console.error('❌ Magic link exception:', err);
      throw err;
    }
  },

  async resetPassword(email) {
    try {
      console.log('Sending password reset to:', email);
      
      const { data, error } = await supabase.auth.resetPasswordForEmail(email, {
        redirectTo: `${window.location.origin}/reset-password`
      });
      
      console.log('Password reset response:', { data, error });
      
      if (error) {
        console.error('Password reset error details:', error);
        throw error;
      }
      
      return data;
    } catch (err) {
      console.error('Password reset exception:', err);
      throw err;
    }
  },

  async updatePassword(newPassword) {
    try {
      const { data, error } = await supabase.auth.updateUser({
        password: newPassword
      });
      
      if (error) {
        console.error('Update password error:', error);
        throw error;
      }
      
      return data;
    } catch (err) {
      console.error('Update password exception:', err);
      throw err;
    }
  },

  async signOut() {
    const { error } = await supabase.auth.signOut();
    if (error) throw error;
  },

  async getSession() {
    const { data: { session }, error } = await supabase.auth.getSession();
    if (error) throw error;
    return session;
  },

  async getUser() {
    const { data: { user }, error } = await supabase.auth.getUser();
    if (error) throw error;
    return user;
  },

  onAuthStateChange(callback) {
    return supabase.auth.onAuthStateChange(callback);
  },

  async updateUserMetadata(metadata) {
    const { data, error } = await supabase.auth.updateUser({
      data: metadata
    });
    
    if (error) throw error;
    return data;
  }
};